export const ACCOUNT_SNAPSHOT_KEY = 'agent_account_snapshot_v1'
export const KEEP_RESULT_KEY = 'agent_keep_result_v1'

const EMPTY_PROGRESS = {
  weekLabel: '',
  planned: 0,
  cooked: 0,
  remainingNights: 0,
  dayLabel: '',
  tonightTitle: null,
}

export function readAccountSnapshot() {
  try {
    const raw = localStorage.getItem(ACCOUNT_SNAPSHOT_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed?.version === 1 ? parsed : null
  } catch {
    return null
  }
}

export function writeAccountSnapshot(snapshot) {
  const current = readAccountSnapshot()
  const next = {
    version: 1,
    ...EMPTY_PROGRESS,
    ...(current || {}),
    ...(snapshot || {}),
    updatedAt: new Date().toISOString(),
  }
  try {
    localStorage.setItem(ACCOUNT_SNAPSHOT_KEY, JSON.stringify(next))
  } catch {
    // Snapshot is a convenience and must never break authentication.
  }
  return next
}

export function writeUserAccountSnapshot(user) {
  if (!user) return null
  return writeAccountSnapshot({ firstName: user.first_name || null })
}

export function clearAccountSnapshot() {
  try {
    localStorage.removeItem(ACCOUNT_SNAPSHOT_KEY)
  } catch {
    // ignore
  }
}

export function keepOkDismissalKey(mergeId) {
  return `agent_keep_ok_dismissed_v1:${mergeId}`
}

export function isKeepOkDismissed(mergeId) {
  if (!mergeId) return false
  try {
    return localStorage.getItem(keepOkDismissalKey(mergeId)) === '1'
  } catch {
    return false
  }
}

export function dismissKeepOk(mergeId) {
  if (!mergeId) return
  try {
    localStorage.setItem(keepOkDismissalKey(mergeId), '1')
  } catch {
    // ignore
  }
  try {
    localStorage.removeItem(KEEP_RESULT_KEY)
  } catch {
    // ignore
  }
}

export function writeKeepResult(result) {
  try {
    localStorage.setItem(KEEP_RESULT_KEY, JSON.stringify(result))
  } catch {
    // ignore
  }
}

export function readKeepResult() {
  try {
    const raw = localStorage.getItem(KEEP_RESULT_KEY)
    if (!raw) return null
    const result = JSON.parse(raw)
    return result?.mergeId && !isKeepOkDismissed(result.mergeId) ? result : null
  } catch {
    return null
  }
}
